import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

const IndustriesPage = () => {
  const industries = [
    {
      icon: 'ri-hospital-line',
      name: 'Healthcare Systems',
      description: 'Comprehensive operational consulting for hospitals, clinics, and healthcare networks seeking accreditation, efficiency improvements, and digital transformation. Our healthcare division, led by Dr. Safwan A. Chaudry through North American Healthcare Group Corp., delivers clinical and operational expertise.',
      services: ['Hospital Operations', 'Accreditation Support', 'Supply Chain Optimization', 'Digital Health', 'Quality Improvement'],
      image: 'https://public.readdy.ai/ai/img_res/368fb0bca607f2ab16dcbc9bf168b5dd.jpg',
    },
    {
      icon: 'ri-truck-line',
      name: 'Transportation & Logistics',
      description: 'Strategic advisory for fleet operators, freight companies, and supply chain enterprises requiring compliance support, operational optimization, and technology integration. We help transportation companies improve efficiency and reduce costs.',
      services: ['Fleet Optimization', 'DOT Compliance', 'Route Planning', 'Warehouse Strategy', 'Technology Integration'],
      image: 'https://readdy.ai/api/search-image?query=aerial%20view%20of%20large%20modern%20logistics%20warehouse%20and%20distribution%20center%20with%20organized%20truck%20fleet%20and%20shipping%20containers%2C%20professional%20freight%20operations%20facility%20with%20efficient%20layout%20and%20industrial%20architecture%2C%20commercial%20transportation%20photography&width=600&height=400&seq=ind-logistics-new-008&orientation=landscape',
    },
    {
      icon: 'ri-gas-station-fill',
      name: 'Energy & Fuel Retail',
      description: 'Market analysis and operational consulting for gas station owners, convenience store operators, and fuel distribution networks. We provide strategic guidance on site development, pricing strategies, and profitability optimization.',
      services: ['Site Feasibility', 'Pricing Strategy', 'Store Merchandising', 'Contract Negotiation', 'Capital Planning'],
      image: 'https://readdy.ai/api/search-image?query=abstract%20petroleum%20industry%20concept%20with%20golden%20fuel%20droplets%20and%20energy%20flow%20visualization%20on%20dark%20background%2C%20artistic%20representation%20of%20oil%20and%20gas%20sector%20with%20metallic%20copper%20and%20amber%20tones%2C%20premium%20corporate%20energy%20industry%20artwork%20without%20any%20brand%20logos%20or%20text&width=600&height=400&seq=ind-energy-new-009&orientation=landscape',
    },
    {
      icon: 'ri-bank-line',
      name: 'Financial Services',
      description: 'Capital advisory and restructuring services for financial institutions, investment firms, and corporate finance departments. We deliver strategic financial consulting that optimizes capital structure and drives growth.',
      services: ['Business Restructuring', 'Capital Planning', 'Financial Modeling', 'Debt Advisory', 'Risk Management'],
      image: 'https://readdy.ai/api/search-image?query=modern%20financial%20district%20skyline%20with%20glass%20skyscrapers%20and%20corporate%20towers%20at%20golden%20hour%2C%20professional%20banking%20and%20finance%20architecture%20with%20reflective%20surfaces%20and%20contemporary%20design%2C%20urban%20commercial%20photography%20with%20warm%20lighting&width=600&height=400&seq=ind-finance-new-010&orientation=landscape',
    },
    {
      icon: 'ri-government-line',
      name: 'Government & Public Sector',
      description: 'Policy consulting and operational advisory for government agencies, public institutions, and regulatory compliance initiatives. We bring private sector efficiency to public sector operations.',
      services: ['Policy Development', 'Operational Efficiency', 'Compliance Advisory', 'Program Management', 'Technology Modernization'],
      image: 'https://readdy.ai/api/search-image?query=majestic%20neoclassical%20government%20building%20with%20grand%20columns%20and%20dome%20architecture%20at%20twilight%20with%20warm%20ambient%20lighting%2C%20impressive%20civic%20institution%20exterior%20with%20American%20flag%20and%20formal%20landscaping%2C%20professional%20architectural%20photography%20of%20public%20administration%20building&width=600&height=400&seq=ind-government-new-011&orientation=landscape',
    },
    {
      icon: 'ri-building-line',
      name: 'Technology Enterprises',
      description: 'Digital transformation and IT infrastructure consulting for technology companies, startups, and enterprise software organizations. We help technology firms scale operations and optimize their technology stack.',
      services: ['IT Strategy', 'Cybersecurity', 'Cloud Migration', 'Software Development', 'AI Integration'],
      image: 'https://readdy.ai/api/search-image?query=futuristic%20technology%20operations%20center%20with%20holographic%20displays%20and%20data%20visualization%20screens%20showing%20analytics%20and%20network%20connections%2C%20modern%20tech%20company%20command%20center%20with%20blue%20ambient%20lighting%20and%20sophisticated%20equipment%2C%20high-end%20corporate%20technology%20photography&width=600&height=400&seq=ind-tech-new-012&orientation=landscape',
    },
  ];

  return (
    <div className="min-h-screen bg-black">
      <Navigation />
      
      <main className="pt-[90px]">
        {/* Hero Section */}
        <section className="bg-gradient-to-b from-[#0A0A0A] to-black py-32">
          <div className="max-w-[1400px] mx-auto px-8">
            <div className="max-w-4xl">
              <div className="inline-flex items-center px-4 py-2 border border-copper/30 rounded-full mb-8">
                <span className="text-xs uppercase tracking-wider text-copper">Industries We Serve</span>
              </div>
              <h1 className="text-6xl lg:text-7xl font-bold text-white mb-8 leading-tight">
                Trusted Across{' '}
                <span className="bg-copper-gradient bg-clip-text text-transparent">
                  Critical Sectors
                </span>
              </h1>
              <p className="text-xl text-gray-400 leading-relaxed">
                MACGOC delivers specialized consulting services across six major industry verticals, combining deep sector expertise with strategic advisory excellence.
              </p>
            </div>
          </div>
        </section>

        {/* Industries Grid */}
        <section className="bg-charcoal-dark py-24">
          <div className="max-w-[1400px] mx-auto px-8">
            <div className="space-y-16">
              {industries.map((industry, index) => (
                <div
                  key={index}
                  className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
                    index % 2 === 1 ? 'lg:flex-row-reverse' : ''
                  }`}
                >
                  {/* Image */}
                  <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                    <div className="relative h-[400px] rounded-2xl overflow-hidden">
                      <img
                        src={industry.image}
                        alt={industry.name}
                        className="w-full h-full object-cover object-top"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                    </div>
                  </div>

                  {/* Content */}
                  <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                    <div className="w-16 h-16 bg-copper/10 rounded-full flex items-center justify-center mb-6">
                      <i className={`${industry.icon} text-5xl text-copper`}></i>
                    </div>
                    <h2 className="text-4xl font-bold text-white mb-6">{industry.name}</h2>
                    <p className="text-lg text-gray-400 leading-relaxed mb-8">
                      {industry.description}
                    </p>
                    <div className="space-y-3">
                      <h3 className="text-sm uppercase tracking-wider text-copper font-semibold">Key Services</h3>
                      <div className="flex flex-wrap gap-3">
                        {industry.services.map((service, idx) => (
                          <span
                            key={idx}
                            className="px-4 py-2 bg-charcoal border border-charcoal-light rounded-full text-sm text-gray-300"
                          >
                            {service}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="bg-black py-24">
          <div className="max-w-[1400px] mx-auto px-8 text-center">
            <h2 className="text-5xl font-bold text-white mb-6">
              Ready to Transform Your Industry?
            </h2>
            <p className="text-xl text-gray-400 mb-10 max-w-2xl mx-auto">
              Discover how MACGOC can deliver specialized consulting services for your sector.
            </p>
            <a
              href="/contact"
              className="inline-flex items-center gap-2 bg-copper hover:bg-copper-light text-white px-12 py-4 rounded-full text-lg font-semibold transition-all duration-300 whitespace-nowrap"
            >
              Get in Touch
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default IndustriesPage;